import * as eventTypes from '../types';
import { SERVER } from '../../config/server.config';
import { addLoadingFlag, subLoadingFlag } from './loading';
import { requestData } from '../../config/services/datasets';
import { practiceFieldUrlBuilder } from '../../helpers/helpers';
import { routeToSpecificScope } from '../../helpers/helpersts';
import { EDIT_ACTION } from '../../config/constants';

export const replacePracticeFields = fields => {
  return {
    type: eventTypes.REPLACE_PRACTICE_FIELDS,
    fields
  };
};

export const loadPracticeFields = (teamId, fieldName) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const specificScope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(specificScope));

    const results = await requestData(SERVER.TEAM_FIELDS(teamId));

    if (results) {
      const [fields] = results;
      const objectFields = {};
      fields.forEach(field => {
        objectFields[field.id] = field;
        // set the newest created field as the selected one on the UI
        if (fieldName && field.areaName === fieldName) {
          dispatch(setPracticeFieldActions({ action: EDIT_ACTION, editingIndex: field.id }));
        }
      });
      dispatch(replacePracticeFields(objectFields));
    }
    dispatch(subLoadingFlag(specificScope));
  };
};

export const addNewPracticeField = (teamId, newField, base64Image) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const specificScope = routeToSpecificScope(path);
    const urlParams = practiceFieldUrlBuilder({ ...newField, teamId });
    dispatch(addLoadingFlag(specificScope));

    const request = {
      method: 'POST',
      body: JSON.stringify({ image: base64Image })
    };

    const results = await fetch(SERVER.LOCAL_FIELDS_POST(teamId) + urlParams, request);

    if (results) {
      dispatch(loadPracticeFields(teamId, newField.areaName));
    }
    dispatch(subLoadingFlag(specificScope));
  };
};

export const editPracticeField = (teamId, practiceField, base64Image) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const specificScope = routeToSpecificScope(path);

    const urlParams = practiceFieldUrlBuilder(practiceField);
    dispatch(addLoadingFlag(specificScope));

    const request = {
      method: 'POST',
      body: base64Image ? JSON.stringify({ image: base64Image }) : {}
    };

    const results = await fetch(SERVER.EDIT_FIELD(teamId) + urlParams, request);

    if (results) {
      dispatch(loadPracticeFields(teamId));
    }

    dispatch(subLoadingFlag(specificScope));
  };
};

export const removePracticeField = (teamId, fieldId) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const specificScope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(specificScope));

    const request = { method: 'DELETE' };
    const results = await fetch(SERVER.SPECIFIC_FIELD(teamId, fieldId), request);

    if (results) {
      dispatch(loadPracticeFields(teamId));
    }

    dispatch(subLoadingFlag(specificScope));
  };
};

export const getAreaFieldImage = (teamId, fieldId) => {
  return async (dispatch, getState) => {
    const state = getState();
    const path = state.router.location.pathname;
    const specificScope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(specificScope));

    const resp = await fetch(SERVER.SPECIFIC_FIELD(teamId, fieldId));
    const data = await resp.json();

    if (data && data.results && data.results.length) {
      const { results } = data;
      const [image] = results;

      const fields = { ...state.practiceFields.fields };
      fields[fieldId] = { ...fields[fieldId], image };
      dispatch(replacePracticeFields(fields));
    }

    dispatch(subLoadingFlag(specificScope));
  };
};

export const setPracticeFieldActions = actions => {
  return dispatch => {
    dispatch({ type: eventTypes.SET_PRACTICE_AREA_ACTIONS, actions });
  };
};
